/** The page ProtectedRoute sent to /login, so the user returns to it after logging in again. */
export const returnPath = (state: unknown): string | null => {
  const from = (
    state as {
      from?: { pathname?: unknown; search?: unknown; hash?: unknown }
    } | null
  )?.from
  if (typeof from?.pathname !== 'string' || !from.pathname.startsWith('/'))
    return null
  return `${from.pathname}${typeof from.search === 'string' ? from.search : ''}${typeof from.hash === 'string' ? from.hash : ''}`
}
